var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDialogInvertedColors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.980694,
    height: 24.979353,
    viewBox: "32 32 8.4615576 6.6091197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "invertFilter"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "table",
    tableValues: "1 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "table",
    tableValues: "1 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "table",
    tableValues: "1 0"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#invertFilter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.01375933,-0.64544565)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.578129,
      strokeDasharray: "none"
    },
    width: 7.1034384,
    height: 5.3535199,
    x: 33.082813,
    y: 33.61198
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.500479,
      strokeDasharray: "none"
    },
    width: 6.6145835,
    height: 1.060293,
    x: 33.32724,
    y: 33.510429
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.01382206,0.11628016)",
    style: {
      stroke: "#000000",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.67728,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 6.9989991,
    height: 5.1297202,
    x: 32.338577,
    y: 32.867805
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.432172,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 6.6218519,
    height: 0.52885151,
    x: 32.446098,
    y: 32.994164
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6599203,0,0,2.6599203,-88.200577,-69.089915)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.54337457,0,0,0.54337457,27.255622,20.271157)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.231258,
      strokeDasharray: "none"
    },
    cx: 33.322918,
    cy: 33.455208,
    r: 0.1322908
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.231258,
      strokeDasharray: "none"
    },
    cx: 33.653648,
    cy: 33.455208,
    r: 0.1322908
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.231258,
      strokeDasharray: "none"
    },
    cx: 33.984375,
    cy: 33.455208,
    r: 0.1322908
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5522667,0,0,0.5522667,20.742239,17.212983)",
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.529167,
      strokeDasharray: "none"
    },
    d: "m 26.697895,32.529165 c 1.322916,0 1.322916,0 1.322916,0 v 2.645833 h 0.79375 v 1.058333 h -2.910416 v -1.058333 h 0.79375 v -1.5875 h -0.79375 v -1.058333 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.529167,
      strokeDasharray: "none"
    },
    id: "path1578",
    cx: 27.359352,
    cy: 31.59532,
    r: 0.66145825
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDialogInvertedColors);
export default __webpack_public_path__ + "static/media/info-dialog-inverted-colors.9e17940226887a770078c3b8896ed543.svg";
export { ForwardRef as ReactComponent };